
export enum ViewType {
  DASHBOARD = 'DASHBOARD',
  
  // Retail Investor (Migrated from old JS app)
  MY_PORTFOLIO = 'MY_PORTFOLIO',
  TRANSACTIONS = 'TRANSACTIONS',
  WATCHLIST = 'WATCHLIST',
  STOCK_ANALYSIS = 'STOCK_ANALYSIS',
  NEWS_INTELLIGENCE = 'NEWS_INTELLIGENCE',
  AI_CHAT = 'AI_CHAT',
  BACKTEST_PAIRS = 'BACKTEST_PAIRS',
  COMMUNITY_HUB = 'COMMUNITY_HUB',
  LIVE_CHAT = 'LIVE_CHAT',
  
  // Front Office (Institutional)
  PORTFOLIO = 'PORTFOLIO',
  CRM = 'CRM',
  STRUCTURING = 'STRUCTURING',
  NEWS_SCANNER = 'NEWS_SCANNER',
  MACRO = 'MACRO',
  MARKET_BREADTH = 'MARKET_BREADTH',
  STRATEGY_LAB = 'STRATEGY_LAB',
  ALGO_STUDIO = 'ALGO_STUDIO',
  RFQ_HUB = 'RFQ_HUB',
  PROGRAM_TRADING = 'PROGRAM_TRADING',
  TCA = 'TCA',
  QUANT_COMPUTING = 'QUANT_COMPUTING',
  SCREENER = 'SCREENER',
  MODEL_REGISTRY = 'MODEL_REGISTRY',

  // Middle Office & Risk
  RISK_MANAGEMENT = 'RISK_MANAGEMENT',
  COUNTERPARTY = 'COUNTERPARTY',
  IPV_CONTROL = 'IPV_CONTROL',
  COLLATERAL = 'COLLATERAL',
  COMPLIANCE = 'COMPLIANCE',

  // Back Office & Ops
  MULTI_ASSET_OPS = 'MULTI_ASSET_OPS',
  RECONCILIATION = 'RECONCILIATION',
  REGULATORY = 'REGULATORY',
  TREASURY = 'TREASURY',
  WORKFLOW = 'WORKFLOW',

  // Data & Tools
  MARKET_DATA = 'MARKET_DATA',
  ANALYTICS = 'ANALYTICS',
  REPORTING = 'REPORTING',
  DOC_INTELLIGENCE = 'DOC_INTELLIGENCE',
  COLLABORATION = 'COLLABORATION',
  ADMIN = 'ADMIN',
  ARCHITECTURE = 'ARCHITECTURE',

  // Research tools
  VALUATION = 'VALUATION',
  EARNINGS_CALENDAR = 'EARNINGS_CALENDAR',
  FACTOR_EXPOSURE = 'FACTOR_EXPOSURE',

  // Insights
  MARKET_INSIGHTS = 'MARKET_INSIGHTS',
  PUBLIC_INSIGHTS = 'PUBLIC_INSIGHTS',
  INSIGHT_TRACK_RECORD = 'INSIGHT_TRACK_RECORD',

  // Quant Lab tools
  KELLY_SIZING = 'KELLY_SIZING',

  // HK Regulatory (Type 11)
  COUNTERPARTY_MONITOR = 'COUNTERPARTY_MONITOR',
  MARGIN_DASHBOARD = 'MARGIN_DASHBOARD',
  CAPITAL_ADEQUACY = 'CAPITAL_ADEQUACY',
  SFC_REPORTING = 'SFC_REPORTING',
}

export interface Trade {
  id: string;
  product: string;
  counterparty: string;
  notional: number;
  currency: string;
  valuation: number;
  status: 'Live' | 'Matured' | 'Verified' | 'Dispute' | 'Settled' | 'Pending';
  tradeDate: string;
  settlementDate: string;
  trader: string;
}

export interface RiskMetric {
  name: string;
  value: string | number;
  change: number;
  status: 'Normal' | 'Warning' | 'Critical';
}

export interface RiskLimit {
  id: string;
  entity: string; // e.g., "Desk: FX Options" or "Counterparty: JP Morgan"
  metric: string; // e.g., "Delta", "Notional", "PV01"
  usage: number;
  limit: number;
  utilization: number; // percentage
}

export interface IPVEntry {
  id: string;
  instrument: string;
  positionId: string;
  internalPrice: number;
  consensusPrice: number;
  variance: number; // percentage
  dollarImpact: number;
  confidence: 'High' | 'Medium' | 'Low';
  source: string; // e.g. "Totem", "Bloomberg", "Broker"
  status: 'Pass' | 'Investigation' | 'Adjusted';
}

export interface NewsItem {
  id: string;
  timestamp: string;
  headline: string;
  source: string;
  category: 'Central Bank' | 'Geopolitics' | 'Regulation' | 'Earnings';
  sentiment: 'Bullish' | 'Bearish' | 'Neutral';
}

export interface NewsImpactAnalysis {
  summary: string;
  affectedAssetClasses: string[];
  projectedPnlImpact: number; // Estimated dollar impact
  recommendedAction: string;
}

export interface AiAnalysisResponse {
  summary: string;
  riskFactors: string[];
  recommendation: string;
}

export interface SimulationConfig {
  useMockData: boolean;
  serverUrl?: string;
}
